import { render, staticRenderFns } from "./addDivisionCore.vue?vue&type=template&id=09b37f50&scoped=true&"
import script from "./addDivisionCore.vue?vue&type=script&lang=js&"
export * from "./addDivisionCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b37f50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b37f50')) {
      api.createRecord('09b37f50', component.options)
    } else {
      api.reload('09b37f50', component.options)
    }
    module.hot.accept("./addDivisionCore.vue?vue&type=template&id=09b37f50&scoped=true&", function () {
      api.rerender('09b37f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionCoreManage/component/addDivisionCore.vue"
export default component.exports